import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import WhatsAppFAB from '../components/WhatsAppFAB';
import HeroSection from '../components/sections/HeroSection';
import StatsSection from '../components/sections/StatsSection';
import ServicesSection from '../components/sections/ServicesSection';
import ControlSection from '../components/sections/ControlSection';
import IdeaSection from '../components/sections/IdeaSection';
import ProductsSection from '../components/sections/ProductsSection';
import PortfolioSection from '../components/sections/PortfolioSection';
import ProcessSection from '../components/sections/ProcessSection';
import TestimonialsSection from '../components/sections/TestimonialsSection';
import FAQSection from '../components/sections/FAQSection';
import ContactSection from '../components/sections/ContactSection';

export default function HomePage() {
  return (
    <div className="min-h-screen bg-[#0B1521] grain-overlay" data-testid="home-page">
      <Navbar />
      <main>
        <HeroSection />
        <StatsSection />
        <ServicesSection />
        <ControlSection />
        <IdeaSection />
        <ProductsSection />
        <PortfolioSection />
        <ProcessSection />
        <TestimonialsSection />
        <FAQSection />
        <ContactSection />
      </main>
      <Footer />
      <WhatsAppFAB />
      <div className="noise-overlay" />
    </div>
  );
}
